import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const isDevelopment = import.meta.env.MODE === "development";

//get persisted lang
let persistedLang = "en";
try {
  const stored = JSON.parse(localStorage.getItem("juzoor-ui-store"));
  if (stored && typeof stored === "object" && stored.state?.language) {
    persistedLang = stored.state.language;
  }
} catch (e) {
  console.log("error checking persisted lang", e);
}

// i18next-http-backend >=3.0.5 rejects namespace names containing "/" (CVE-2026-41691).
// Use flat namespace identifiers and a loadPath function to map them to subdirectory paths.
const nsFolderMap = {
  projectTranslation: "Projects",
  userTranslation: "Users",
  errorTranslation: "Error",
  authTranslation: "Auth",
  layoutTranslation: "Layout",
  profileTranslation: "Profile",
};

// i18next v26 no longer exposes initPromise as a property on the instance.
// Capture the promise returned by .init() and export it for use in the provider.
export const i18nInitPromise = i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: persistedLang,
    fallbackLng: "ar",
    load: "languageOnly", // Remove duplicate
    debug: isDevelopment,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: (langs, namespaces) => {
        const ns = namespaces[0];
        const folder = nsFolderMap[ns];
        return folder
          ? `/locales/${langs[0]}/${folder}/${ns}.json`
          : `/locales/${langs[0]}/${ns}.json`;
      },
      requestOptions: {
        cache: "default",
      },
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    ns: [
      "projectTranslation",
      "userTranslation",
      "errorTranslation",
      "authTranslation",
      "layoutTranslation",
      "profileTranslation",
    ],
    defaultNS: "projectTranslation",

    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
    },

    supportedLngs: ["en", "ar"],
  });

export default i18n;
